import React from 'react';
import { findDOMNode } from 'react-dom';
import { HocWrapper } from '../hoc-wrapper';

export default function withMouseMove<P>(
  Component: HocWrapper<P>,
): React.ComponentClass<P> {
  class WrappedComponent extends React.Component<P, any> {
    public static displayName = '';
    public wrappedInstance = null;
    public wrappedDomNode = null;

    public componentDidMount() {
      window.addEventListener('mousemove', this.handleMouseMove, true);
    }

    public componentWillUnmount() {
      window.removeEventListener('mousemove', this.handleMouseMove, true);
    }

    public render() {
      const { ...props } = this.props as any;

      return (
        <Component
          {...props}
          ref={el => {
            this.wrappedInstance = el;
            this.wrappedDomNode = findDOMNode(el);
          }}
        />
      );
    }

    private handleMouseMove = e => {
      if (typeof this.wrappedInstance.handleMouseMove === 'function') {
        this.wrappedInstance.handleMouseMove(e);
      }
    };
  }

  const name = WrappedComponent.displayName || WrappedComponent.name;
  WrappedComponent.displayName = `withMouseMove(${name})`;

  return WrappedComponent;
}
